import Vue from "vue";

export default {
  computed: {
    awaitingConsent() {
      return (
        this.ticket.assigned &&
        this.ticket.consentable &&
        !this.ticket.consented
      );
    },

    isComplete() {
      return this.ticket.state === "complete";
    },

    isIncompleteOrSnoozed() {
      return this.ticket.state === "incomplete" || this.ticket.snoozed;
    },

    isStarted() {
      // The 'started' state is being removed. Check ticket is started using old and new way temporarily because we can't deploy :dashboard and :js simultaneously.
      return this.ticket.state === "started" || (this.ticket.assigned === false && this.ticket.snoozed === false);
    },

    lastStartedTicket() {
      return this.isStarted && !this.nextStartedTicket;
    },

    nextStartedTicket() {
      if (this.registration) {
        return this.$store.getters["registration/firstStartedTicket"](
          this.registration.slug
        );
      }
    },

    promptToAssign() {
      return !this.ticket.assigned && !this.ticket.changes_locked;
    },

    promptToComplete() {
      return (
        this.ticket.assigned &&
        this.ticket.state === "incomplete" &&
        !this.ticket.changes_locked &&
        !this.showAwaitingConsentFromTicketHolder
      );
    },

    releaseTitle() {
      if (
        this.ticket.release.translations &&
        this.ticket.release.translations[this.locale]
      ) {
        return this.ticket.release.translations[this.locale].title;
      }
      return this.ticket.release.title;
    },

    status() {
      if (!this.ticket.assigned) {
        return this.$t(
          "views.registrations.overlays._inline_ticket.unassigned",
          this.locale
        );
      } else if (this.ticket.state == "incomplete") {
        return this.$t("views.tickets._header.unissued", this.locale);
      } else if (this.ticket.state == "cancelled") {
        return this.$t("views.tickets._header.cancelled", this.locale);
      } else if (this.ticket.state == "complete") {
        return this.$t("views.tickets._header.issued", this.locale);
      }
    },

    statusClass() {
      return {
        "tito-ticket-unassigned": !this.ticket.assigned,
        "tito-ticket-incomplete":
          this.ticket.assigned && this.ticket.state !== "complete",
        "tito-ticket-complete": this.ticket.state === "complete",
        "tito-ticket-void": this.ticket.state === "void",
      };
    },

    statusIcon() {
      if (this.ticket.state == "void") {
        return ["fas", "times"];
      } else  if (!this.ticket.assigned) {
        return ["fas", "user"];
      } else if (this.ticket.state == "complete") {
        return ["fas", "check"];
      } else {
        return ["fas", "circle-notch"];
      }
    },

    showAwaitingConsentFromTicketHolder() {
      return (
        this.awaitingConsent &&
        this.registration &&
        this.registration.email != this.ticket.email
      );
    },
  },

  methods: {
    afterUpdateRoute() {
      if (this.nextStartedTicket) {
        return {
          name: "registrationTicket",
          params: { locale: this.locale, ticketId: this.nextStartedTicket.slug },
        };
      } else if (this.lastStartedTicket) {
        return { name: "registration", params: { locale: this.locale } };
      } else if (this.registration) {
        return { name: "registrationTicket", params: { locale: this.locale, ticketId: this.ticket.slug } };
      } else {
        return { name: "ticket", params: { locale: this.locale, ticketId: this.ticket.slug } };
      }
    },

    back() {
      if (this.isStarted) {
        this.showWhoChooser();
      } else {
        this.$router.push(this.backRoute());
      }
    },

    backRoute() {
      if (this.registration) {
        return {
          name: "registrationTicket",
          params: { ticketId: this.ticket.slug },
        };
      } else {
        return { name: "ticket" };
      }
    },

    reloadRegistrationOrTicket() {
      if (this.registration) {
        return this.$store.dispatch(
          "registration/get",
          this.$route.params.registrationId
        );
      } else {
        return this.$store.dispatch("ticket/get", this.ticket.slug);
      }
    },

    scrollToFirstInvalidField() {
      const firstInvalidField = document.querySelector(".invalid-field");
      if (!firstInvalidField) return;
      firstInvalidField.scrollIntoView();

      const label = firstInvalidField.querySelector("label");
      if (!label) return;
      label.focus();
    },

    setErrors(error) {
      if (error.response && error.response.data) {
        this.errors = error.response.data.errors;

        // Scroll to first invalid field after a delay to give time for errors to render.
        setTimeout(this.scrollToFirstInvalidField, 500);
      }
    },

    showWhoChooser() {
      this.$emit("input", "");
    },
  },
};
